import { NuxtAxiosInstance } from '@nuxtjs/axios'
import BaseRepository from '../BaseRepository'

export default class UsersRepository extends BaseRepository {
  constructor (protected endpoint: string, axios: NuxtAxiosInstance) {
    super(endpoint, axios)
  }

  getUserInfo () {
    return this.$axios.get(`${this.endpoint}`)
  }
}
